import { crimsonText, lato } from '../utils/localFonts';
import { getDefaultTheme } from './default-theme/default-theme';

export default getDefaultTheme({
  color: {
    primary: '#a00000',
    secondary: '#333333',
    error: '#ea252a',
    brand: {
      main: '#f2e3c6',
      text: '#fff',
    },
    text: {
      primary: '#333333',
      secondary: '#777777',
      linkColor: '#b62f27',
      hoverLinkColor: '#ff0000',
    },
  },
  font: {
    base: `${lato.style.fontFamily}`,
    sans: `${lato.style.fontFamily}`,
    serif: `${crimsonText.style.fontFamily}`,
  },
});
